import {
  Directive,
  OnInit,
  ElementRef,
  Renderer2,
  HostListener
} from '@angular/core';

import { Subscription } from 'rxjs';
import { NgControl } from '@angular/forms';

import { KeyboardService } from '../keyboard.service';
import { DecimalPipe } from '@angular/common';
enum MaskExpression {
  EMPTY_STRING = '',
  DOT = '.',
  COMMA = ',',
  MINUS = '-',
}
@Directive({
  // tslint:disable-next-line:directive-selector
  selector: 'input[oskInputNum]',
  providers: [DecimalPipe],
  exportAs: 'oskInputNum',
})
export class OskInputNumDirective implements OnInit {
  private keySubscription: Subscription;
  private backspaceSubscription: Subscription;
  private enterSubscription: Subscription;
  private measure: HTMLElement;
  private allowNegativeNumbers = false;
  private decimalMarker = ',';
  private thousandSeparator = '.';


  constructor(private render: Renderer2,
    private el: ElementRef, private keyboard: KeyboardService,
              private ngControl: NgControl,
              private decimalPipe: DecimalPipe) {}

  ngOnInit() {
    // TODO I'm sure there's an "Angular way" of doing this
    const thisStyle = window.getComputedStyle(this.el.nativeElement);
    this.measure = document.createElement('span');
    this.measure.style.position = 'absolute';
    this.measure.style.right = '100%';
    this.measure.style.font = thisStyle.font;
    document.body.appendChild(this.measure);
    this.el.nativeElement.value = this.decimalPipe.transform(this.el.nativeElement.value.replaceAll('.', '').replaceAll(',', '.'), '1.2-2');
  }

  @HostListener('focus')
  private onFocus() {
    this.keyboard.fireKeyboardRequested(true);
    this.subscribeToKeyboardEvents();
  }

  @HostListener('input', ['$event']) private onInput(event: Event): void {
    const target = event.target as HTMLInputElement;
    target.value = target.value.toUpperCase().replace(/[a-zA-Zç;.?><_=+/ºª%$#"!|()&´`«»'}{*^~\t\n]/gi, '');
  }

  @HostListener('blur')
  private onBlur() {
    this.keyboard.fireKeyboardRequested(false);
    this.unsubscribeFromKeyboardEvents();
  }

  private subscribeToKeyboardEvents() {
    this.keySubscription = this.keyboard.keyPressed.subscribe(key =>
      this.onKey(key)
    );
    this.backspaceSubscription = this.keyboard.backspacePressed.subscribe(_ =>
      this.onBackspace()
    );
    this.enterSubscription = this.keyboard.enterPressed.subscribe(_ =>
      this.onEnter()
    );
  }

  private unsubscribeFromKeyboardEvents() {
    this.keySubscription.unsubscribe();
    this.backspaceSubscription.unsubscribe();
    this.enterSubscription.unsubscribe();
  }

  private _stripToDecimal(str: string): string {
    return str
      .split(MaskExpression.EMPTY_STRING)
      .filter((i: string, idx: number) => {
        const isDecimalMarker =
          typeof this.decimalMarker === 'string'
            ? i === this.decimalMarker
            : // TODO (inepipenko) use utility type
            (this.decimalMarker as string).includes(
              i as MaskExpression.COMMA | MaskExpression.DOT
            );
        return (
          i.match('^-?\\d') ||
          i === this.thousandSeparator ||
          isDecimalMarker ||
          (i === MaskExpression.MINUS && idx === 0 && this.allowNegativeNumbers)
        );
      })
      .join(MaskExpression.EMPTY_STRING);
  }

  private onKey(key: string) {
    if (key && key === '.') {
      return;
    }
    let inputCurrentValue = this.el.nativeElement.value;
    const valorComVirgula = this.el.nativeElement.value;
    // TODO Refactor this into a single method with the code in onBackspace
    const element = this.el.nativeElement,
      start = element.selectionStart,
      end = element.selectionEnd;

    // Verificar se tem pontos e substituir //
    // if (inputCurrentValue.includes('.') || !inputCurrentValue.includes(',')) {
    //   inputCurrentValue = inputCurrentValue.replaceAll('.', '');
    //   this.ngControl.control.setValue(inputCurrentValue);
    // }

    // Se inclui virgulas, verificar se tem digitos depois da virgula //
    // const splitLength = inputCurrentValue && (inputCurrentValue.split(',')[1]) ? (inputCurrentValue.split(',')[1]).toString().length : 0;
    // if (inputCurrentValue.includes(',') && splitLength > 0 && splitLength < 2) {
    //   inputCurrentValue = inputCurrentValue.replace(',', '.');
    //   this.ngControl.control.setValue(inputCurrentValue);
    // }

    // if (inputCurrentValue.includes(',') && splitLength >= 2) {
    //   inputCurrentValue = inputCurrentValue.split(',')[0] + ',' + inputCurrentValue.split(',')[1].slice(0, 2);
    //   inputCurrentValue = inputCurrentValue.replace(',', '.');
    //   this.ngControl.control.setValue(this._stripToDecimal(inputCurrentValue));
    //   return;
    // }

    
    // if (inputCurrentValue.includes(',')) {
    //   inputCurrentValue = inputCurrentValue.split(',')[0] + ',' + inputCurrentValue.split(',')[1].slice(0, 2);
    //   inputCurrentValue = inputCurrentValue.replace(',', '.');
    //   this.ngControl.control.setValue(this._stripToDecimal(inputCurrentValue));
    //   return;
    // }


    this.measure.textContent = element.value.substr(0, start) + key;
    element.value =
      element.value.substr(0, start) + key + element.value.substr(end);

    element.focus();
    element.selectionStart = element.selectionEnd = start + 1;

    this.updateScrollPosition();
  }

  private onBackspace() {
    let element = this.el.nativeElement,
      start = element.selectionStart,
      end = element.selectionEnd;

    if (start === 0) {
      return;
    }

    if (start === end) {
      start--;
    }
    this.measure.textContent = element.value.substr(0, start);
    element.value = element.value.substr(0, start) + element.value.substr(end);
    element.focus();
    element.selectionStart = element.selectionEnd = start;
    this.updateScrollPosition();
  }

  private updateScrollPosition() {
    const element = this.el.nativeElement;
    element.scrollLeft = this.measure.offsetWidth - (element.clientWidth - 10);
    if (element.value && !this.ngControl.control.value) {
      this.ngControl.control.setValue(element.value.replaceAll(',', '.'));
    }
    const event = new Event('input', { bubbles: true });
    this.el.nativeElement.dispatchEvent(event);
  }

  private onEnter() {

  }

}
